export const environment = {
  production: true,
  server: 'https://ai.meetzy.es',
  mcpUrl: 'https://mcp.meetzy.es/mcp',
  firebase: {
    apiKey: "AIzaSyAmn_ejDUsgbwHPoo8xjZY4d7jOgz0c10U",
    authDomain: "ultrafocus-2c011.firebaseapp.com",
    projectId: "ultrafocus-2c011",
    storageBucket: "ultrafocus-2c011.appspot.com",
    messagingSenderId: "997245029033",
    appId: "1:997245029033:web:d6b0076917b6fba79737b8",
    measurementId: "G-MG1W7TQBGJ"
  }
};
